
// import React, { useState, useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import "../components/Auth/Auth.css";
// import logoImg from "../assets/logo_on_white.png";

// const ForgotPassword = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [step, setStep] = useState(1);
//   const [email, setEmail] = useState(location.state?.email || "");
//   const [companyLogo, setCompanyLogo] = useState(null);
//   const [companyName, setCompanyName] = useState("GENESIS_TECH_ENGINEERS");
//   const [otp, setOtp] = useState("");
//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);

//   /* Helper function for API calls */
//   const callAPI = async (url, body) => {
//     const res = await fetch(url, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(body)
//     });

//     const text = await res.text();
//     try {
//       return JSON.parse(text);
//     } catch {
//       console.error("Invalid JSON:", text);
//       throw new Error("Server returned invalid response");
//     }
//   };

//   /* STEP 1 : SEND OTP */
//   const sendOTP = async () => {
//     if (!email) {
//       alert("Please enter your email");
//       return;
//     }

//     setLoading(true);
//     try {
//       const data = await callAPI("/gt-api/send_otp.php", { email });
//       if (data.success) {
//         alert("OTP sent to your email");
//         setStep(2);
//       } else {
//         alert(data.message || "Unable to send OTP");
//       }
//     } catch (error) {
//       console.error(error);
//       alert("Server error while sending OTP");
//     }
//     setLoading(false);
//   };

//   /* STEP 2 : VERIFY OTP */
//   const verifyOTP = async () => {
//     if (!otp) {
//       alert("Enter OTP");
//       return;
//     }

//     setLoading(true);
//     try {
//       const data = await callAPI("/gt-api/verify_otp.php", { email, otp });
//       if (data.success) {
//         alert("OTP verified");
//         setStep(3);
//       } else {
//         alert(data.message || "Invalid OTP");
//       }
//     } catch (error) {
//       console.error(error);
//       alert("OTP verification failed");
//     }
//     setLoading(false);
//   };

//   /* STEP 3 : RESET PASSWORD */
//   const resetPassword = async () => {
//     if (!password || !confirmPassword) {
//       alert("Enter password in both fields");
//       return;
//     }

//     if (password !== confirmPassword) {
//       alert("Passwords do not match");
//       return;
//     }

//     if (password.length < 8) {
//       alert("Password must be at least 8 characters");
//       return;
//     }

//     setLoading(true);
//     try {
//       const data = await callAPI("/gt-api/reset_password.php", { email, password });
//       if (data.success) {
//         alert("Password reset successful");
//         navigate("/");
//       } else {
//         alert(data.message || "Unable to reset password");
//       }
//     } catch (error) {
//       console.error(error);
//       alert("Password reset error");
//     }
//     setLoading(false);
//   };

//   useEffect(() => {
//     document.body.classList.remove("light-mode");
//     document.documentElement.classList.remove("light-mode");

//     return () => {
//       document.body.classList.add("light-mode");
//       document.documentElement.classList.add("light-mode");
//     };
//   }, []);

//   useEffect(() => {
//     const emailParts = email.split("@");
//     if (emailParts.length !== 2) {
//       setCompanyLogo(null);
//       setCompanyName("GENESIS_TECH_ENGINEERS");
//       return;
//     }

//     const domain = emailParts[1];
//     fetch("/gt-api/get_company_logo.php", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json"
//       },
//       body: JSON.stringify({ domain })
//     })
//       .then(res => res.json())
//       .then(data => {
//         if (data.success) {
//           setCompanyName(data.org_name);
//           if (data.company_logo) {
//             setCompanyLogo(`/gt-api/${data.company_logo}`);
//           } else {
//             setCompanyLogo(null);
//           }
//         } else {
//           setCompanyLogo(null);
//           setCompanyName("GENESIS_TECH_ENGINEERS");
//         }
//       })
//       .catch(() => {
//         setCompanyLogo(null);
//         setCompanyName("GENESIS_TECH_ENGINEERS");
//       });
//   }, [email]);

//   return (
//     <div className="split-auth-page light-mode-page">
//       <div className="login-page-background-overlay"></div>

//       <div className="login-container-card">
//         {/* LEFT COLUMN - HCM PORTAL BRANDING */}
//         <div className="login-card-left">
//           <div className="hcm-left-header">
//             <div className="company-info">
//               <span className="company-logo-text">GTELINQ</span>
//               <span className="portal-badge">HCM PORTAL</span>
//             </div>
//           </div>

//           <div className="hcm-left-body">
//             <h1 className="brand-quote">
//               Human <br />
//               <span className="nowrap-line">
//                 <span className="text-highlight underline-text">Capital</span> Management.
//               </span>
//             </h1>

//             <h2 className="brand-subline">
//               Streamlining <span className="text-highlight">Enterprise</span> Workflows.
//             </h2>
//           </div>

//           <div className="hcm-left-footer">
//             <span className="secure-badge">
//               <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lock-svg">
//                 <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
//                 <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
//               </svg>
//               Secure HCM Platform Connection
//             </span>
//           </div>
//         </div>

//         {/* RIGHT COLUMN - PASSWORD RESET FORM */}
//         <div className="login-card-right">
//           <div className="form-wrapper">
//             <div className="auth-portal-header">
//               <div className="logo-hex-frame">
//                 <img
//                   src={companyLogo || logoImg}
//                   alt="Company Logo"
//                   className="auth-center-logo"
//                 />
//               </div>
//               <h3 className="portal-title">{companyName}</h3>
//               <p className="portal-subtitle">Reset your account access credentials.</p>
//             </div>

//             {/* STEP 1: ENTER EMAIL */}
//             {step === 1 && (
//               <div className="main-form">
//                 <div className="input-group">
//                   <label className="onboarding-label">Corporate Email</label>
//                   <div className="input-with-icon">
//                     <span className="input-icon">
//                       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
//                         <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
//                         <circle cx="12" cy="7" r="4"></circle>
//                       </svg>
//                     </span>
//                     <input
//                       type="email"
//                       className="onboarding-input"
//                       placeholder="abc@genesistech.com"
//                       value={email}
//                       onChange={(e) => setEmail(e.target.value)}
//                     />
//                   </div>
//                 </div>

//                 <button
//                   className="primary-submit onboarding-btn"
//                   onClick={sendOTP}
//                   disabled={loading}
//                 >
//                   <span>{loading ? "Sending..." : "Send OTP"}</span>
//                 </button>
//               </div>
//             )}

//             {/* STEP 2: ENTER OTP */}
//             {step === 2 && (
//               <div className="main-form">
//                 <div className="input-group">
//                   <label className="onboarding-label">Enter OTP</label>
//                   <div className="input-with-icon">
//                     <span className="input-icon">
//                       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
//                         <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
//                         <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
//                       </svg>
//                     </span>
//                     <input
//                       type="text"
//                       className="onboarding-input"
//                       placeholder="Enter OTP"
//                       value={otp}
//                       onChange={(e) => setOtp(e.target.value)}
//                     />
//                   </div>
//                 </div>

//                 <button
//                   className="primary-submit onboarding-btn"
//                   onClick={verifyOTP}
//                   disabled={loading}
//                 >
//                   <span>{loading ? "Verifying..." : "Verify OTP"}</span>
//                 </button>
//               </div>
//             )}

//             {/* STEP 3: RESET PASSWORD */}
//             {step === 3 && (
//               <div className="main-form">
//                 <div className="input-group">
//                   <label className="onboarding-label">New Password</label>
//                   <div className="input-with-icon">
//                     <span className="input-icon">
//                       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
//                         <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
//                         <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
//                       </svg>
//                     </span>
//                     <input
//                       type={showPassword ? "text" : "password"}
//                       className="onboarding-input password-input"
//                       placeholder="Enter new password"
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                     />
//                     <button
//                       type="button"
//                       className="password-toggle-btn"
//                       onClick={() => setShowPassword(!showPassword)}
//                     >
//                       {showPassword ? (
//                         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="eye-svg">
//                           <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
//                           <line x1="1" y1="1" x2="23" y2="23"></line>
//                         </svg>
//                       ) : (
//                         <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="eye-svg">
//                           <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
//                           <circle cx="12" cy="12" r="3"></circle>
//                         </svg>
//                       )}
//                     </button>
//                   </div>
//                 </div>

//                 <div className="input-group">
//                   <label className="onboarding-label">Confirm Password</label>
//                   <div className="input-with-icon">
//                     <span className="input-icon">
//                       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
//                         <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
//                         <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
//                       </svg>
//                     </span>
//                     <input
//                       type="password"
//                       className="onboarding-input"
//                       placeholder="Confirm password"
//                       value={confirmPassword}
//                       onChange={(e) => setConfirmPassword(e.target.value)}
//                     />
//                   </div>
//                 </div>

//                 <button
//                   className="primary-submit onboarding-btn"
//                   onClick={resetPassword}
//                   disabled={loading}
//                 >
//                   <span>{loading ? "Resetting..." : "Reset Password"}</span>
//                 </button>
//               </div>
//             )}

//             <div className="back-link-container">
//               <span className="back-to-email-link" onClick={() => navigate("/")}>
//                 ← Back to Login
//               </span>
//             </div>

//             <div className="portal-form-footer">
//               <p className="footer-warning">Protected System Access Node.</p>
//               <p className="footer-warning">All activities are logged and monitored.</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ForgotPassword;



























import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../components/Auth/Auth.css";
import logoImg from "../assets/logo_on_white.png";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [step, setStep] = useState(1);
  const [email, setEmail] = useState(location.state?.email || "");
  const [companyLogo, setCompanyLogo] = useState(null);
  const [companyName, setCompanyName] = useState("GENESIS_TECH_ENGINEERS");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  /* Helper function for API calls */
  const callAPI = async (url, body) => {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    });

    const text = await res.text();
    try {
      return JSON.parse(text);
    } catch {
      console.error("Invalid JSON:", text);
      throw new Error("Server returned invalid response");
    }
  };

  /* STEP 1 : SEND OTP */
  const sendOTP = async () => {
    if (!email) {
      alert("Please enter your email");
      return;
    }

    setLoading(true);
    try {
      const data = await callAPI("/gt-api/send_otp.php", { email });
      if (data.success) {
        alert("OTP sent to your email");
        setStep(2);
      } else {
        alert(data.message || "Unable to send OTP");
      }
    } catch (error) {
      console.error(error);
      alert("Server error while sending OTP");
    }
    setLoading(false);
  };

  /* STEP 2 : VERIFY OTP */
  const verifyOTP = async () => {
    if (!otp) {
      alert("Enter OTP");
      return;
    }

    setLoading(true);
    try {
      const data = await callAPI("/gt-api/verify_otp.php", { email, otp });
      if (data.success) {
        alert("OTP verified");
        setStep(3);
      } else {
        alert(data.message || "Invalid OTP");
      }
    } catch (error) {
      console.error(error);
      alert("OTP verification failed");
    }
    setLoading(false);
  };

  /* STEP 3 : RESET PASSWORD */
  const resetPassword = async () => {
    if (!password || !confirmPassword) {
      alert("Enter password in both fields");
      return;
    }

    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    if (password.length < 8) {
      alert("Password must be at least 8 characters");
      return;
    }

    setLoading(true);
    try {
      const data = await callAPI("/gt-api/reset_password.php", { email, password });
      if (data.success) {
        alert("Password reset successful");
        navigate("/");
      } else {
        alert(data.message || "Unable to reset password");
      }
    } catch (error) {
      console.error(error);
      alert("Password reset error");
    }
    setLoading(false);
  };

  useEffect(() => {
    document.body.classList.remove("light-mode");
    document.documentElement.classList.remove("light-mode");
  }, []);

  useEffect(() => {
    const emailParts = email.split("@");
    if (emailParts.length !== 2) {
      setCompanyLogo(null);
      setCompanyName("GENESIS_TECH_ENGINEERS");
      return;
    }

    const domain = emailParts[1];
    fetch("/gt-api/get_company_logo.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ domain })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setCompanyName(data.org_name);
          if (data.company_logo) {
            setCompanyLogo(`/gt-api/${data.company_logo}`);
          } else {
            setCompanyLogo(null);
          }
        } else {
          setCompanyLogo(null);
          setCompanyName("GENESIS_TECH_ENGINEERS");
        }
      })
      .catch(() => {
        setCompanyLogo(null);
        setCompanyName("GENESIS_TECH_ENGINEERS");
      });
  }, [email]);

  return (
    <div className="split-auth-page light-mode-page">
      <div className="login-page-background-overlay"></div>

      <div className="login-container-card">
        {/* LEFT COLUMN - HCM PORTAL BRANDING */}
        <div className="login-card-left">
          <div className="hcm-left-header">
            <div className="company-info">
              <span className="company-logo-text">GTELINQ</span>
              <span className="portal-badge">HCM PORTAL</span>
            </div>
          </div>

          <div className="hcm-left-body">
            <h1 className="brand-quote">
              Human <br />
              <span className="nowrap-line">
                <span className="text-highlight underline-text">Capital</span> Management.
              </span>
            </h1>

            <h2 className="brand-subline">
              Streamlining <span className="text-highlight">Enterprise</span> Workflows.
            </h2>
          </div>

          <div className="hcm-left-footer">
            <span className="secure-badge">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lock-svg">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
              Secure HCM Platform Connection
            </span>
          </div>
        </div>

        {/* RIGHT COLUMN - PASSWORD RESET FORM */}
        <div className="login-card-right">
          <div className="form-wrapper">
            <div className="auth-portal-header">
              <div className="logo-hex-frame">
                <img
                  src={companyLogo || logoImg}
                  alt="Company Logo"
                  className="auth-center-logo"
                />
              </div>
              <h3 className="portal-title">{companyName}</h3>
              <p className="portal-subtitle">Reset your account access credentials.</p>
            </div>

            {/* STEP 1: ENTER EMAIL */}
            {step === 1 && (
              <div className="main-form">
                <div className="input-group">
                  <label className="onboarding-label">Corporate Email</label>
                  <div className="input-with-icon">
                    <span className="input-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                      </svg>
                    </span>
                    <input
                      type="email"
                      className="onboarding-input"
                      placeholder="abc@genesistech.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>

                <button
                  className="primary-submit onboarding-btn"
                  onClick={sendOTP}
                  disabled={loading}
                >
                  <span>{loading ? "Sending..." : "Send OTP"}</span>
                </button>
              </div>
            )}

            {/* STEP 2: ENTER OTP */}
            {step === 2 && (
              <div className="main-form">
                <div className="input-group">
                  <label className="onboarding-label">Enter OTP</label>
                  <div className="input-with-icon">
                    <span className="input-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                      </svg>
                    </span>
                    <input
                      type="text"
                      className="onboarding-input"
                      placeholder="Enter OTP"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                    />
                  </div>
                </div>

                <button
                  className="primary-submit onboarding-btn"
                  onClick={verifyOTP}
                  disabled={loading}
                >
                  <span>{loading ? "Verifying..." : "Verify OTP"}</span>
                </button>
              </div>
            )}

            {/* STEP 3: RESET PASSWORD */}
            {step === 3 && (
              <div className="main-form">
                <div className="input-group">
                  <label className="onboarding-label">New Password</label>
                  <div className="input-with-icon">
                    <span className="input-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                      </svg>
                    </span>
                    <input
                      type={showPassword ? "text" : "password"}
                      className="onboarding-input password-input"
                      placeholder="Enter new password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      className="password-toggle-btn"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="eye-svg">
                          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                          <line x1="1" y1="1" x2="23" y2="23"></line>
                        </svg>
                      ) : (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="eye-svg">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                          <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                      )}
                    </button>
                  </div>
                </div>

                <div className="input-group">
                  <label className="onboarding-label">Confirm Password</label>
                  <div className="input-with-icon">
                    <span className="input-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                      </svg>
                    </span>
                    <input
                      type="password"
                      className="onboarding-input"
                      placeholder="Confirm password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                  </div>
                </div>

                <button
                  className="primary-submit onboarding-btn"
                  onClick={resetPassword}
                  disabled={loading}
                >
                  <span>{loading ? "Resetting..." : "Reset Password"}</span>
                </button>
              </div>
            )}

            <div className="back-link-container">
              <span className="back-to-email-link" onClick={() => navigate("/")}>
                ← Back to Login
              </span>
            </div>

            <div className="portal-form-footer">
              <p className="footer-warning">Protected System Access Node.</p>
              <p className="footer-warning">All activities are logged and monitored.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;